import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import './App.scss';
import {
  IPolygonLayer,
  IUploadedLayer,
} from './components/Map/Layer/DatasetZoneLayer';
import { StoreContext, StoreData } from './store/store';
import { IPreviewAnalytic } from './typings/analytics';
import { ICountry, ICurrentUser, IInfoResult } from './typings/api';
import { ILegend, MarkerItem } from './typings/home';
import { MenuListItem } from './typings/menu';
import {
  IDatasetBrief,
  IEnrichedMetadata,
  IMetadataItem,
} from './typings/metadata';
import { ShoppingItem } from './typings/shopping';
import { createMenuListData } from './views/Menu/Component/MenuList';
import Home from './views/Home/Home';
import { ILabelLayer, MapBoundsZoom } from './typings/map';
import CheckoutPage from './views/Pages/Checkout/Checkout';
import MainMapContainer from './views/Home/Component/Main/MainMap';
import { INotification } from './views/Home/Component/Notifications/INotification';
import LoadingProvider from './context/loadingContext/LoadingProvider';
import { hasCookieConsent } from './generic/cookieUtils';
import CookieBanner from './components/Modals/CookieBanner';
import { DataProvider } from './views/ResultPanel/Store/DatasetContext';
import { IFWEPoint, IInsituPoint } from './api/FileEndPoint';
import { IConfig } from './typings/config';
import getConfig from './api/config';

function App() {
  const [loadingDataFromBSApi, setLoadingDataFromBSApi] = useState<boolean>(false)
  const [activePopupPoint, setActivePopupPoint] = useState('')
  const [isChangeDatasetWarningVisible, setIsChangeDatasetWarningVisible] =
    useState({
      SW: false,
      HD: false,
      Wind: false
    });
  const [closeValidation, setCloseValidation] = useState<boolean>(false)
  const [depth, setDepth] = useState({});
  const [cellSize, setCellSize] = useState({});
  const [isAnalyticsVisible, setIsAnalyticsVisible] = useState({});
  const [fwePoints, setFWEPoints] = useState<IFWEPoint[]>([]);
  const [showFWEPoints, setShowFWEPoints] = useState<boolean>(false);
  const [fweDatasetBriefs, setFWEDatasetBrief] = useState<IDatasetBrief[]>([]);
  const [fweModelDomains, setFWEModelDomains] = useState<IPolygonLayer[]>([]);
  const [inSituPoints, setInSituPoints] = useState<IInsituPoint[]>([]);
  const [showInSituPoints, setShowInSituPoints] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const [showNotifications, setShowNotifications] = useState<boolean>(false);
  const [user, setUser] = useState<ICurrentUser>({} as any);
  const [metadatas, setMetadatas] = useState<IMetadataItem[]>([]);
  const [previewAnalytics, setPreviewAnalytics] = useState<IPreviewAnalytic[]>(
    []
  );
  const [datasetBriefs, setDatasetBrief] = useState<IDatasetBrief[]>([]);
  const [enrichedMetadata, setEnrichedMetadata] = useState<IEnrichedMetadata[]>(
    []
  );
  const [showPricingModal, setShowPricingModal] = useState<boolean>(false);
  const [showContactModal, setShowContactModal] = useState<boolean>(false);
  const [showDownloadApiModal, setShowDownloadApiModal] = useState(false)
  const [showFeaturesModal, setShowFeaturesModal] = useState<boolean>(false);
  const [showGetStartedModal, setShowGetStartedModal] =
    useState<boolean>(false);
  const [showCart, setShowCart] = useState<boolean>(false);
  const [showUserProfile, setShowUserProfile] = useState<boolean>(false);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [showUploadedShapefile, setShowUploadedShapefile] = useState(false);
  const [uploadedShapefile, setUploadedShapefile] = useState<IPolygonLayer[]>(
    []
  );
  const [uploadedFeatures, setUploadedFeatures] = useState<IUploadedLayer[]>(
    []
  );
  const [uploadingShapefile, setUploadingShapefile] = useState<boolean>(false);
  const [visibleUploads, setVisibleUploads] = useState<Array<string>>([]);
  const [shoppingItems, setShoppingItems] = useState<{
    [key: string]: { [key: string]: ShoppingItem };
  }>({});
  const [menuList, setMenuList] = useState<MenuListItem[]>(() =>
    createMenuListData()
  );
  const [selectDataset, setSelectDataset] = useState<IDatasetBrief | null>(
    null
  );
  const [selectedSearchId, setSelectedSearchId] = useState<string>('');
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [searchId, setSearchId] = useState<string>('');
  const [showMaintenanceBanner, setShowMaintenanceBanner] =
    useState<string>('false');
  const [showAdvertisingBanner, setShowAdvertisingBanner] =
    useState<string>('false');
  const [advertisingBannerButtonText, setAdvertisingBannerButtonText] =
    useState<string>('');
  const [markerCollections, setMarkerCollections] = useState<MarkerItem[]>([]);
  const [point, setPoint] = useState<MarkerItem>({} as any);
  const [datasetZones, setDatasetZones] = useState<IPolygonLayer[]>([]);
  const [showDatasetZones, setShowDatasetZones] = useState<boolean>(true);
  const [showLabelLayer, setShowLabelLayer] = useState<boolean>(true);
  const [mapBoundsZoom, setMapBoundsZoom] = useState<MapBoundsZoom>({
    bounds: [0, 0, 0, 0],
    zoom: 1,
  });
  const [legend, setLegend] = useState<ILegend>({} as any);
  const [showLayerView, setShowLayerView] = useState<boolean>(false);
  const [showGraticuleLayer, setShowGraticuleLayer] = useState<boolean>(false);
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [showSpectraModal, setShowSpectraModal] = useState<boolean>(false);
  const [addingPointToMap, setAddingPointToMap] = useState<boolean>(false);
  const [showResultCollapse, setShowResultCollapse] = useState<boolean>(false);
  const [countryList, setCountryList] = useState<ICountry[]>([]);
  const [segmentsList, setSegmentsList] = useState<IInfoResult[]>([]);
  const [companySizeList, setCompanySizeList] = useState<IInfoResult[]>([]);
  const [userProfileUpdated, setUserProfileUpdated] = useState<boolean>(false);
  const [graticule, setGraticule] = useState<{
    lines: GeoJSON.Feature<GeoJSON.LineString>[];
    points: ILabelLayer[];
  }>({} as any);
  const [overridePointData, setOverridePointData] = useState<boolean>(true);
  const [showAssociateToCompany, setShowAssociateToCompany] = useState<{ status: boolean, fun: () => void }>({
    status: false, fun: () => null
  });
  const [showSubscriptionExpiredModal, setShowSubscriptionExpiredModal] = useState<{
    message: string, header: string, status: boolean
  }>({
    message: '', header: '', status: false
  })

  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(false);
  const [activeCategoryKey, setActiveCategoryKey] = useState<{[key: string] : string | string[]}>({});
  const [userGroupPermissions, setUserGroupPermissions] = useState<{}>({});
  const [datasetOffline, setDatasetOffline] = useState({});
  const [datasetReport, setDatasetReport] = useState({});
  const [dropdownSearchbarOpen, setDropdownSearchbarOpen] = useState(false)
  const [showGlobalShapeFile, setShowGlobalShapeFile] = useState(true)
  const [showGlobalTextShapeFile, setShowGlobalTextShapeFile] = useState(false)
  const [showMesh, setShowMesh] = useState(true)
  const [showSurfaceMap, setShowSurfaceMap] = useState(true)
  const [timeStepInterval, setTimeStepInterval] = useState('60')
  const [addPointName, setAddPointName] = useState('')

  useEffect(() => {
    const configData = async () => {
      const json: IConfig = await getConfig();
      return json;
    };

    configData().then((json) => {
      // Init tracking in Matomo
      if (document.location.hostname === json.matomoHostname) {
        const _paq = (window._paq = window._paq || []);
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['setDocumentTitle', document.location.hostname + '/' + document.title]);
        _paq.push(['setCookieDomain', document.location.hostname]);
        _paq.push(['setDomains', [document.location.hostname]]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        const u = 'https://dhigroup.matomo.cloud/';
        _paq.push(['setTrackerUrl', u + 'matomo.php']);
        _paq.push(['setSiteId', '31']);
        const d = document;
        const g = d.createElement('script');
        const s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = '//cdn.matomo.cloud/dhigroup.matomo.cloud/matomo.js';
        if (s && s.parentNode) {
          s.parentNode.insertBefore(g, s);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!hasCookieConsent()) {
      const timeoutId = setTimeout(() => {
        setShowCookieBanner(true);
      }, 3000);

      return () => clearTimeout(timeoutId); // Clear the theme timeout on unmount
    }
  }, []);

  const handleConsent = () => {
    setShowCookieBanner(false);
  };

  const handleReject = () => {
    setShowCookieBanner(false);
  };

  return (
    <StoreContext.Provider
      value={{
        ...new StoreData(),
        loadingDataFromBSApi, setLoadingDataFromBSApi,
        closeValidation,
        setCloseValidation,
        activeCategoryKey,
        setActiveCategoryKey,
        activePopupPoint,
        setActivePopupPoint,
        fwePoints,
        setFWEPoints,
        showFWEPoints,
        setShowFWEPoints,
        fweDatasetBriefs,
        setFWEDatasetBrief,
        fweModelDomains,
        setFWEModelDomains,
        inSituPoints,
        setInSituPoints,
        showInSituPoints,
        setShowInSituPoints,
        notifications,
        setNotifications,
        showNotifications,
        setShowNotifications,
        userProfileUpdated,
        setUserProfileUpdated,
        countryList,
        setCountryList,
        segmentsList,
        setSegmentsList,
        companySizeList,
        setCompanySizeList,
        user,
        setUser,
        datasetBriefs,
        setDatasetBrief,
        showPricingModal,
        setShowPricingModal,
        showContactModal,
        setShowContactModal,
        showDownloadApiModal,
        setShowDownloadApiModal,
        showFeaturesModal,
        setShowFeaturesModal,
        showGetStartedModal,
        setShowGetStartedModal,
        showCart,
        setShowCart,
        showUserProfile,
        setShowUserProfile,
        menuCollapse,
        setMenuCollapse,
        showLayerView,
        setShowLayerView,
        menuList,
        setMenuList,
        showSearch,
        setShowSearch,
        showMaintenanceBanner,
        setShowMaintenanceBanner,
        showAdvertisingBanner,
        setShowAdvertisingBanner,
        advertisingBannerButtonText,
        setAdvertisingBannerButtonText,
        searchId,
        setSearchId,
        shoppingItems,
        setShoppingItems,
        markerCollections,
        setMarkerCollections,
        point,
        setPoint,
        datasetZones,
        setDatasetZones,
        showDatasetZones,
        setShowDatasetZones,
        showLabelLayer,
        setShowLabelLayer,
        showUploadedShapefile,
        setShowUploadedShapefile,
        uploadedShapefile,
        setUploadedShapefile,
        uploadedFeatures,
        setUploadedFeatures,
        uploadingShapefile,
        setUploadingShapefile,
        visibleUploads,
        setVisibleUploads,
        mapBoundsZoom,
        setMapBoundsZoom,
        legend,
        setLegend,
        previewAnalytics,
        setPreviewAnalytics,
        metadatas,
        setMetadatas,
        enrichedMetadata,
        setEnrichedMetadata,
        showLogin,
        setShowLogin,
        setShowSpectraModal,
        showSpectraModal,
        addingPointToMap,
        setAddingPointToMap,
        showResultCollapse,
        setShowResultCollapse,
        graticule,
        setGraticule,
        showGraticuleLayer,
        setShowGraticuleLayer,
        overridePointData,
        setOverridePointData,
        showAssociateToCompany,
        setShowAssociateToCompany,
        showSubscriptionExpiredModal,
        setShowSubscriptionExpiredModal,
        isChangeDatasetWarningVisible,
        setIsChangeDatasetWarningVisible,
        isAnalyticsVisible,
        setIsAnalyticsVisible,
        userGroupPermissions,
        setUserGroupPermissions,
        depth,
        setDepth,
        cellSize,
        setCellSize,
        selectDataset,
        setSelectDataset,
        datasetOffline,
        setDatasetOffline,
        selectedSearchId,
        setSelectedSearchId,
        datasetReport,
        setDatasetReport,
        dropdownSearchbarOpen,
        setDropdownSearchbarOpen,
        showGlobalShapeFile,
        setShowGlobalShapeFile,
        showGlobalTextShapeFile,
        setShowGlobalTextShapeFile,
        showMesh,
        setShowMesh,
        showSurfaceMap,
        setShowSurfaceMap,
        timeStepInterval,
        setTimeStepInterval,
        addPointName,
        setAddPointName
      }}
    >
      <DataProvider>
        <LoadingProvider>
          <BrowserRouter>
            <Home>
              <Routes>
                <Route path="/" element={<MainMapContainer />} />
                <Route path="/app" element={<MainMapContainer />} />
                <Route
                  path="/activation/:activateCode"
                  element={<MainMapContainer />}
                />
                <Route path="/pricing" element={<MainMapContainer />} />
                <Route path="/contact" element={<MainMapContainer />} />
                <Route path="/features" element={<MainMapContainer />} />
                <Route path="/getstarted" element={<MainMapContainer />} />
                <Route path="/api" element={<MainMapContainer />} />
                <Route path="/notifications" element={<MainMapContainer />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/paymentfailure" element={<CheckoutPage />} />
                <Route path="/paymentsuccess" element={<MainMapContainer />} />
                <Route path="/metadata" element={<MainMapContainer />} />
                <Route path="/metadata/:datasetID" element={<MainMapContainer />} />
              </Routes>
            </Home>
          </BrowserRouter>
          {showCookieBanner && (
            <CookieBanner onConsent={handleConsent} onReject={handleReject} />
          )}
        </LoadingProvider>
      </DataProvider>
    </StoreContext.Provider>
  );
}

export default App;
